import React from 'react'
import DefaultLayout from '../../components/layout/DefaultLayout'
import dummayimage from '../../assets/images/dummay/dummay.png';
import { useFormik } from 'formik';
import PasswordFiled from '../../components/Form/PasswordField';
export default function ResetPassword() {
  const formik = useFormik({
    initialValues:{
      email:''
    }
  })
  return (
    <DefaultLayout>
      <div className=" ">
        <div className=" h-full overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 h-full">
      <div className='py-10 pl-2 md:pl-20'>
        <h1 className='h1'>Reset Password</h1>
        <p className="p pt-4 md:pt-10">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. In eu mi bibendum neque egestas congue.
        </p>
        <div className="pt-5">
          <form onSubmit={formik.handleSubmit} >
          <PasswordFiled
                        label="Email"
                        name="password"
                        placeholder="Password"
                        formik={formik}
                      />
          <PasswordFiled
                        label="Email"
                        name="password"
                        placeholder="Confirm Password"
                        formik={formik}
                      />
                      <div className="py-8 flex items-center justify-center">
                      <button className='btn-primary'>
                Reset
              </button>
                      </div>
            
          </form>
        </div>
      </div>
      <div className='h-screen object-cover'>
        <img src={dummayimage} className="w-full h-full" alt="" />
      </div>
    </div>
        </div>
      </div>
   
    </DefaultLayout>
  )
}
